import { useState } from 'react';
// import Link from '@mui/material/Link';
import { Link } from 'react-router-dom';
import bars from '../components/images/menu1.svg';
import '../styles/navbar.css';


// const pages = ["Home", "Menu", "Book"];

function Navbar() {
  const [isNavExpanded, setIsNavExpanded] = useState(false);
  

  return (
    <nav className='navigation'>
      {/*  --- Logo  --- */}
      <div>
        <a href='/' className='brand-name' > FLORAL. </a>
      </div>
      {/* --- inbetween space --- */}

      <button 
        className='hamburger'
        onClick={() => {
          setIsNavExpanded(!isNavExpanded);
        }}
      > 
      <img src={bars} className="hamburger" />        
      </button>

      <div
        className={
          isNavExpanded ? "navigation-menu expanded" : "navigation-menu"
        }
      >
        <ul>
          <li onClick={() => {
          setIsNavExpanded(!isNavExpanded);
        }}>
            <Link to='/'>Home</Link>
          </li>
          <li onClick={() => {
          setIsNavExpanded(!isNavExpanded);
        }}>
            <Link to="/Menu">Menu</Link>
          </li>
          <li  onClick={() => {
          setIsNavExpanded(!isNavExpanded);
        }}>
            <Link to="/Book">Book</Link>
          </li>
        </ul>
      </div>




    </nav>

  );
}

export default Navbar;

